import axios from 'axios';
import { setCookie, getCookie } from './cookie';

const isNewVersion = (to) => {
  // 使用 to.fullPath 代替 window.location.href，因为 router.beforeEach 触发时
  // History API 尚未更新，window.location.href 仍是跳转前的旧地址
  let fullUrl = to ? to.fullPath : window.location.href;
  if (fullUrl.toLocaleLowerCase().indexOf('/admin/preparations/index') != -1 ||
    fullUrl.toLocaleLowerCase().indexOf('/student/selfreport/index') != -1 ||
    fullUrl.toLocaleLowerCase().indexOf('/login') != -1 ) {
    let url = `//${window.location.host}/version.json?t=${new Date().getTime()}`;
    // let url = `//${window.location.host}/version.json?t=${process.env.VUE_APP_VERSION}`;
    axios.get(url).then(res => {
      if (res.status === 200) {
        let vueVersion = res.data.version || '1.0.0';
        let localVueVersion = getCookie('vueVersion');
        if (!localVueVersion || localVueVersion != vueVersion) {
          setCookie('vueVersion', vueVersion, 365);
          setTimeout(function () {
            window.location.reload(true);
            return false;
          }, 100);
        }
      }
    });
  }
}

export default {
  isNewVersion
}
